const formatRecipientAddress = (address) => {
  if (!address) return null;

  const clean = (value) => (typeof value === "string" ? value.trim() : "");
  const street = [clean(address.address1), clean(address.address2)].filter(Boolean).join(", ");
  const stateAndPostcode = [clean(address.state), clean(address.postcode)].filter(Boolean).join(" ");
  const line = [street, clean(address.city), stateAndPostcode].filter(Boolean).join(", ");

  return line || null;
};

export default formatRecipientAddress;
